"use client";

import { SectionTitle } from "./sectionTitle";

const ThWithPadding = ({ children }: { children: React.ReactNode }) => {
	return (
		<td className="border border-gray-300 px-2 py-1 md:px-4 md:py-3 text-left font-bold bg-gray-200">
			{children}
		</td>
	);
};

const TdWithPadding = ({
	children,
	rowSpan,
}: { children: React.ReactNode; rowSpan?: number }) => {
	return (
		<td
			className="border border-gray-300 px-2 py-1 md:px-4 md:py-3"
			rowSpan={rowSpan}
		>
			{children}
		</td>
	);
};

export const Schedule = () => {
	const scheduleData = [
		{
			day: "1日目 キックオフ会",
			date: "12/16 (火)",
			location: "@対面&オンライン",
			activities: [
				{ time: "17:00 - 17:05", activity: "開会式" },
				{ time: "17:05 - 17:10", activity: "課題説明" },
				{ time: "17:10 - 17:25", activity: "ビジネス講義" },
				{ time: "17:25 - 18:00", activity: "企業によるメンタリング①" },
				{ time: "", activity: "学生間メンタリング" },
			],
		},
		{
			day: "2日目",
			date: "12/17 (水)",
			location: "@対面&オンライン",
			activities: [
				{ time: "17:00 - 18:00", activity: "企業によるメンタリング②" },
			],
		},
		{
			day: "3日目",
			date: "12/18 (木)",
			location: "@対面&オンライン",
			activities: [
				{ time: "17:00 - 17:30", activity: "企業による技術講義①" },
				{ time: "17:30 - 18:00", activity: "企業による技術講義②" },
			],
		},
		{
			day: "4日目",
			date: "12/19 (金)",
			location: "@対面&オンライン",
			activities: [
				{ time: "17:00 - 18:00", activity: "フリー" },
				{ time: "21:00", activity: "事前資料提出" },
			],
		},
		{
			day: "5日目 最終発表会",
			date: "12/20 (土)",
			location: "@対面&オンライン",
			activities: [
				{ time: "10:00 - 10:10", activity: "開会式" },
				{ time: "10:10 - 10:20", activity: "コンテスト説明" },
				{ time: "10:20 - 12:00", activity: "プレゼン発表①" },
				{ time: "12:00 - 13:00", activity: "お昼休み" },
				{ time: "13:00 - 16:00", activity: "プレゼン発表②" },
				{ time: "16:00 - 17:00", activity: "審査 & 受賞式" },
				{ time: "17:00 - 18:00", activity: "クロージング" },
			],
		},
	];

	return (
		<div className="flex flex-col gap-4">
			<SectionTitle title="スケジュール" />

			<div className="overflow-x-auto">
				<table className="w-full border-collapse border-2 border-gray-300 bg-[#EBEBEB] text-sm md:text-md rounded-2xl font-bold">
					<thead>
						<tr>
							<ThWithPadding>Day</ThWithPadding>
							<ThWithPadding>Date (Day of Week)</ThWithPadding>
							<ThWithPadding>Location</ThWithPadding>
							<ThWithPadding>Time</ThWithPadding>
							<ThWithPadding>Activity</ThWithPadding>
						</tr>
					</thead>
					<tbody className="bg-white">
						{scheduleData.map((day) =>
							day.activities.map((activity, activityIndex) => (
								<tr key={`${day.day}-${activity.activity}-${activityIndex}`}>
									{activityIndex === 0 && (
										<>
											<TdWithPadding rowSpan={day.activities.length}>
												{day.day.split(" ").map((text) => (
													<span key={text}>
														<span>{text}</span>
														<br />
													</span>
												))}
											</TdWithPadding>
											<TdWithPadding rowSpan={day.activities.length}>
												{day.date}
											</TdWithPadding>
											<TdWithPadding rowSpan={day.activities.length}>
												{day.location}
											</TdWithPadding>
										</>
									)}
									<TdWithPadding>{activity.time}</TdWithPadding>
									<TdWithPadding>{activity.activity}</TdWithPadding>
								</tr>
							)),
						)}
					</tbody>
				</table>
			</div>
		</div>
	);
};
